/** @jsx jsx */

import { jsx } from '@emotion/core';

import {
  Grid,
  Tag,
  Tooltip,
  TooltipFocusableTrigger,
} from '@zapier/design-system';

import StatusLabel from 'app/developer-v3/components/StatusLabel';
import { APP_STATUSES } from 'app/developer-v3/constants';
import { AppStatusName, SubmitStatus } from 'app/developer-v3/types/statuses';

import { STATUS_LABEL_VARIANT_MAP, STATUS_TOOLTIP_MAP } from './constants';

import type { Version } from './types';

type Props = {
  status: AppStatusName;
  version: Version;
  versionStatusLabel: string;
};

function ColumnStatus({ status, version, versionStatusLabel }: Props) {
  return (
    <Grid alignItems="center" columns="repeat(2, max-content)" gap="5px">
      <Tooltip
        allowMultiline={true}
        content={STATUS_TOOLTIP_MAP[version.lifecycle.status] || ''}
      >
        <TooltipFocusableTrigger>
          <StatusLabel
            label={versionStatusLabel}
            variant={STATUS_LABEL_VARIANT_MAP[version.lifecycle.status]}
          />
        </TooltipFocusableTrigger>
      </Tooltip>
      {/* Add a tooltip for pushed back status */}
      {status === APP_STATUSES.pending.name &&
        version.submitStatus === SubmitStatus.pushedBack && (
          <Tooltip
            allowMultiline={true}
            content="During our review we found some issues with this version. Create a new editable version by cloning your integration."
          >
            <TooltipFocusableTrigger>
              <Tag variant="inverted">Review Denied</Tag>
            </TooltipFocusableTrigger>
          </Tooltip>
        )}
    </Grid>
  );
}

export default ColumnStatus;
